export enum HelpMenuEvent {
    HelpMenuToggled = 'HelpMenuEvent.HelpMenuToggled',
}

type HelpMenuToggledPayload = {
    opened: boolean;
};

export interface HelpMenuEventMap {
    [HelpMenuEvent.HelpMenuToggled]: HelpMenuToggledPayload;
}
